var exports = {
  "k": "xe533113f--56a026--container",
};

module.exports = exports;
